import { render } from "./TariffePage.vue?vue&type=template&id=627900b0&scoped=true"
import script from "./TariffePage.vue?vue&type=script&lang=js"
export * from "./TariffePage.vue?vue&type=script&lang=js"

import "./TariffePage.vue?vue&type=style&index=0&id=627900b0&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-627900b0"]])

export default __exports__